import React, { useEffect, useState } from 'react'
import { ClientService } from '../../component/services/client.service';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUniversity } from '@fortawesome/free-solid-svg-icons';
import { Button, Card, Col, Form, Row, Tab, Tabs } from 'react-bootstrap';
import Select from "react-select"
import CetLoader from '../../component/Loader/CetLoader';
import ReverificationTable from '../../component/table/Reverification.table';
import TablePaginationComponent from '../../component/table/TablePagination';
import moment from 'moment';
import { CSVLink } from "react-csv";
import downloadjs from "downloadjs"
import toast from 'react-hot-toast';
import { FiRefreshCw } from "react-icons/fi";

interface FilterOption {
    label: string;
    value: string;
}

export default function ReverificationsDetails() {
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);
    const [streams, setStreams] = useState<any>([]);
    const [selectedStreams, setSelectedStreams] = useState<any>();
    const [reverifications, setReverifications] = useState<any>();
    const [selectedCollege, setSelectedCollege] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [colleges, setColleges] = useState<any[]>([]);

    const getAllUsersReverifications = async () => {
        setLoading(true);
        const payload = {
            colleges: selectedCollege?.map((data:any) => data?.value) || [],
            streams: selectedStreams?.map((data:any) => data?.value) || [],
        }
        await ClientService.getAllUsersReverifications(payload).then((res) => {
            if (res.status === 200) {
                setReverifications(res.data?.data);
            }
        }).catch((err) => {
            console.log(err)
            setLoading(false)
            toast.error(err?.response?.data?.message || err?.response?.data || 'Failed to fetch colleges');
        }).finally(() => {
            setLoading(false)
        })
    }

    const getAllStreams = async () => {
        await ClientService.getAllStreams().then((res) => {
            if (res.status === 200) {
                setStreams(res.data.streams.map((data: any) => {
                    return {
                        label: data,
                        value: data
                    }
                }))
            }
        })
    }

    async function fetchColleges() {
        setLoading(true);
        await ClientService.getReverificationColleges()
            .then((res: any) => {
                if (res.status === 200) {
                    const collegeOptions = res.data?.data?.map((college: any) => ({
                        value: college?.collegId,
                        label: college?.collegeName
                    })) || [];
                    setColleges(collegeOptions);
                } else {
                    console.error("Failed to fetch colleges:", res);
                }
            })
            .catch((error: any) => {
                console.error("Error fetching colleges:", error);
                toast.error(error?.response?.data?.message || 'Failed to fetch colleges');
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const handleCollegesChange = (selectedOptions: any) => {
        let newSelectedStates: FilterOption[] = [];

        if (selectedOptions?.some((option: any) => option.value === "All")) {
            newSelectedStates = colleges.map((college: any) => ({
                label: college.label,
                value: college.value,
            }));
        } else {
            newSelectedStates = selectedOptions || [];
        }

        setSelectedCollege(newSelectedStates);

    };

    const handleStreamChange = (selectedOptions: any) => {
        let newSelectedStates: FilterOption[] = [];

        if (selectedOptions?.some((option: any) => option.value === "All")) {
            newSelectedStates = streams.map((college: any) => ({
                label: college.label,
                value: college.value,
            }));
        } else {
            newSelectedStates = selectedOptions || [];
        }

        setSelectedStreams(newSelectedStates);

    };

    useEffect(() => {
            getAllUsersReverifications();
    }, [selectedCollege, selectedStreams])

    useEffect(() => {
        fetchColleges();
        getAllStreams();
    }, []);

    return (
        <>

            <Card className="mt-4 mb-5 shadow" style={{ borderRadius: "16px", border: "1px solid #e9ecef" }}>

                <Card.Body className="p-4">
                    <div className='d-flex justify-content-end'>
                        <FiRefreshCw className='fw-bold' size={22} style = {{cursor: "pointer"}} onClick={getAllUsersReverifications} />
                    </div>
                    <Card
                        className="mt-3 mb-3"
                        style={{
                            backgroundColor: "#f9f9f9",
                            borderRadius: "12px",
                            border: "none",
                        }}
                    >
                        <Card.Body>
                            <div className="d-flex align-items-center gap-3">
                                <div>
                                    <Form.Label className="text-muted fw-bold">Select College</Form.Label>
                                    <Select
                                        value={selectedCollege}
                                        options={[
                                            { label: "All", value: "All" },
                                            ...(colleges || [])
                                        ]}
                                        placeholder="Select College"
                                        onChange={handleCollegesChange}
                                        isClearable
                                        isMulti
                                    />
                                </div>
                                <div>
                                    <Form.Label className="text-muted fw-bold">Select Course</Form.Label>
                                    <Select
                                        options={[
                                            { label: "All", value: "All" },
                                            ...(streams || [])
                                        ]}
                                        placeholder="Select Course"
                                        onChange={handleStreamChange}
                                        isClearable
                                        isMulti
                                        value={selectedStreams}
                                    />
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                            <h5 className="text-secondary fw-bold mb-3" style={{ fontSize: '18px' }}>
                                Reverifications
                            </h5>
                        </div>
                        {/*
                    <div>
                        {csvData && csvData.length > 0 ? (
                            <CSVLink
                                data={csvData}
                                filename={`Reverifications.csv`}
                                className="btn btn-sm btn-primary"
                                onClick={downloadReverificationCSV}
                            >
                                {csvLoading ? "Preparing..." : "Ready to Download CSV"}
                            </CSVLink>
                        ) : (
                            <Button onClick={downloadReverificationCSV} size="sm" disabled={csvLoading}>
                                {csvLoading ? "Preparing..." : "Download CSV"}
                            </Button>
                        )}
                        <Button onClick={downloadReverificationCSV} size="sm" disabled={csvLoading}>
                            {csvLoading ? "Preparing..." : "Download CSV"}
                        </Button>
                    </div>
                            */}
                    </div>

                    {loading ? (
                        <div className="mt-4">
                            <CetLoader />
                        </div>
                    ) : selectedCollege || selectedStreams ? (
                        <>
                            {/* <Card className="mt-4 shadow" style={{ borderRadius: "16px", border: "1px solid #e9ecef" }}>
                            <Card.Body className="p-4"> */}

                            <Tabs>
                                <Tab eventKey={"Both Matched"} title={`Both Matched (${reverifications?.both_matched?.length || 0})`}>
                                    <Row className="g-3">
                                        <ReverificationTable tableData={reverifications?.both_matched || []} />
                                    </Row>
                                </Tab>
                                <Tab eventKey={"fingerprint"} title={`Only Fingerprint Matched (${reverifications?.only_fingerprint?.length || 0})`}>
                                    <Row className="g-3">
                                        <ReverificationTable tableData={reverifications?.only_fingerprint || []} />
                                    </Row>
                                </Tab>
                                <Tab eventKey={"face"} title={`Only Face Matched (${reverifications?.only_facial?.length || 0})`}>
                                    <Row className="g-3">
                                        <ReverificationTable tableData={reverifications?.only_facial || []} />
                                    </Row>
                                </Tab>
                                <Tab eventKey={"none"} title={`Both not matched (${reverifications?.none_matched?.length || 0})`}>
                                    <Row className="g-3">
                                        <ReverificationTable tableData={reverifications?.none_matched || []} />
                                    </Row>
                                </Tab>
                            </Tabs>
                            {/* </Card.Body>
                        </Card> */}
                        </>
                    ) : selectedCollege ? (
                        <NoDataView message="No data available for the selected college." />
                    ) : (
                        <div>
                            {loading ? <div>Loading...</div> :
                                <NoDataView message="Please select a college to view data." />
                            }
                        </div>
                    )}
                </Card.Body>
            </Card>

        </>
    )
}

const NoDataView = ({ message }: { message: string }) => {
    return (
        <div className="text-center py-5">
            <div className="mb-3">
                <FontAwesomeIcon
                    icon={faUniversity}
                    className="text-muted"
                    style={{ fontSize: '48px', opacity: 0.3 }}
                />
            </div>
            <div className="text-muted" style={{ fontSize: '16px' }}>
                {message || "No college data available."}
            </div>
        </div>
    );
}
